// Prod token template. The deploy stage renames this to env.js before build, so #{token}#
// is baked into the config chunk and replacetokens fills it from portal-ui-{intg,prod}.
window.IntegrationsAppConfig = {
  ENVIRONMENT: "#{environment}#",
  IDENTITY_SERVER_URL: "#{identityServerUrl}#",
  PUBLIC_API_URL: "#{publicApiUrl}#",
  PORTAL_API_URL: "#{portalApiUrl}#",
  USER_MANAGEMENT_API_URL: "#{userManagementApiUrl}#",
  PORTAL_URL: "#{portalUrl}#",
  APP_CLIENT_COOKIE_NAME: "#{appClientCookieName}#",
  AUTH0_CLIENTID: "#{auth0ClientId}#",
  AUTH0_DOMAIN: "#{auth0Domain}#",
};
